import { combineReducers } from 'redux';
import { actionTypes } from 'actions/authenticate';
import authenticate from './authenticate';
import clinicManager from './clinicManager';
import currentPatient from './currentPatient';
import patientAdherence from './patientAdherence';
import patientDetailsList from './patientDetailsList';

const appReducer = combineReducers({
  authenticate,
  clinicManager,
  currentPatient,
  patientAdherence,
  patientDetailsList,
});

const rootReducer = (
  state: IRootStateType | undefined,
  action: Action<any>,
): any => {
  if (action.type === actionTypes.RESET_ALL_AFTER_LOGOUT) {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export default rootReducer;
